import React from 'react';
import { DatePicker } from '@shopify/polaris';
import { handleFilterChange } from '../FilterEngine';

const createdAtAfterFilterDefinition = (t, props, setTableFilters, selected, selectedMonthYear) => ({
  key: 'created-at-after',
  label: t('filters.after'),
  filter: (
    <DatePicker
      month={selectedMonthYear.month}
      year={selectedMonthYear.year}
      onChange={handleFilterChange(props, setTableFilters, 'createdAtAfter', 'date')}
      onMonthChange={handleFilterChange(props, setTableFilters, 'createdAtAfterMonthYear', 'monthYear')}
      selected={selected}
    />
  ),
  shortcut: true
});

export default createdAtAfterFilterDefinition;
